export default class OrderResponse {
	is_successful = false;
	error_message = null;
	additional_error_data = [];

	constructor(response) {
		this.is_successful = response.IsSuccessful;
		this.error_message = response.ErrorMessage;
		this.additional_error_data =
			!response.IsSuccessful &&
			response.AdditionalErrorData.map(errorInfo => ({
				latest_available_quantity: errorInfo.LatestAvailableQuantity,
				id: errorInfo.Id,
				is_pack: errorInfo.IsPack,
			}));
	}
}



// WEBPACK FOOTER //
// ./src/api/models/OrderResponse.js